import axios from 'axios';
import { withTurnstile } from '../utils/turnstile';
import { apiClient } from '../utils/api';
import { params } from '../modules/events/movePages';
import { procedureIdSelected, selectedProcedures } from '../utils/variables';

export async function sendOTPCode(phoneNumber) {
    // Turnstile token rides along when the project requires captcha (same gate as
    // the lead POST) — the API's OTP route verifies it (SMS-pumping guard, 9/2026).
    return await apiClient.POST('api/twilio/verification/token', await withTurnstile({
        phone: phoneNumber,
    }));
}

export async function checkOTPCode(phoneNumber, otpCode) {
    return await apiClient.POST('api/appointment-token', {
        phone: phoneNumber,
        code: otpCode,
    });
}

export async function loginPortal(phoneNumber, otpCode, project, visitorId) {
    return await axios.request({
        headers: {
            ...apiClient.config().headers,
        },
        method: 'POST',
        url: `${apiClient.apiUrl(
            `api/widget/project/${project}/login/phone/${phoneNumber}`
        )}`,
        data: {
            phone: phoneNumber,
            code: otpCode,
            project,
            visitor_id: visitorId,
        },
    });
}

// Ids of the service(s) the visitor picked earlier in the booking flow.
// Service lists record the choice in selectedProcedures; single-service and
// URL-preselected flows use procedureIdSelected. Accept either.
function selectedProcedureIds() {
    const ids = [];
    if (procedureIdSelected) ids.push(procedureIdSelected);
    if (Array.isArray(selectedProcedures)) ids.push(...selectedProcedures);
    return [
        ...new Set(
            ids.map((id) => parseInt(id, 10)).filter((id) => Number.isInteger(id) && id > 0)
        ),
    ];
}

export async function createBookingToken(appointmentChannelId, payload) {
    // The lead is created HERE, two screens after the service was picked, so
    // the selection has to ride along — otherwise a drop-off before the final
    // confirm leaves a lead (and its "Unfinished Booking" ticket) with no
    // service. The API validates the ids against the channel and ignores junk.
    const procedureIds = selectedProcedureIds();

    // booking-token creates the lead when none matches, so it carries the same
    // Turnstile token as POST api/leads for spam-gated projects.
    return await apiClient.POST(
        `api/widget/appointment-channel/${appointmentChannelId}/booking-token`,
        await withTurnstile(procedureIds.length ? { ...payload, procedure_ids: procedureIds } : payload)
    );
}

export async function updateLeadPortal(lead_id, data) {
  if (parseInt(params('has_source')) === 1 && params('source')) {
    data['source'] = params('source');
  }
    return await apiClient.POST(`api/widget/leads/${lead_id}`, data);
}

export async function getCSRFToken() {
    return await apiClient.GET('sanctum/csrf-cookie');
}
